import Image from 'next/legacy/image';

import { H2, H3, H4, H5 } from '../../../common/headline';

import trackAppPreviewWithIconsMobile from '@public/img/how-it-works/track-app-preview-with-icons-mobile.png';
import trackAppPreviewDesktop from '@public/img/how-it-works/track-app-preview-desktop.png';
import trackAppPreviewIconsDesktop from '@public/img/how-it-works/track-app-preview-icons-desktop.png';

export const WhatYouCanExpect = (): JSX.Element => (
  <div className="flex flex-col lg:container lg:m-auto lg:flex-row">
    <div className="text-blue lg:mr-[83px] lg:w-2/5">
      <div className="mt-[76px] px-4 text-center lg:hidden">
        <H3>What you can expect</H3>
      </div>
      <div className="mt-[52%] hidden max-w-[500px] px-0 text-left lg:block">
        <H2>What you can expect</H2>
      </div>
      <div className="mt-4 px-[26px] text-center lg:hidden">
        <H5>
          Get the tools, scientific knowledge, and support needed to create a
          healthier lifestyle that lasts.
        </H5>
      </div>
      <div className="mt-[24px] hidden max-w-[473px] px-0 text-left lg:block">
        <H4>
          Get the tools, scientific knowledge, and support needed to create a
          healthier lifestyle that lasts.
        </H4>
      </div>
    </div>
    <div className="mt-[52px] lg:mt-[178px] lg:w-3/5">
      <div className="md:hidden">
        <Image
          src={trackAppPreviewWithIconsMobile}
          width={1125}
          height={1419}
          alt="App preview with icons"
        />
      </div>
      <div className="hidden md:flex">
        <div>
          <Image
            src={trackAppPreviewIconsDesktop}
            width={963}
            height={1326}
            alt="App preview with icons"
          />
        </div>
        <div>
          <Image
            src={trackAppPreviewDesktop}
            width={1323}
            height={1557}
            alt="App preview with icons"
          />
        </div>
      </div>
    </div>
  </div>
);
